<template>
  <div
    id="page"
    class="
      xl:w-4/5
      md:w-11/12
      xl:my-3
      md:my-2
      md:mx-auto
      m-1
      bg-gray-50
      rounded
      animate-fade-in-down-op
    "
  >
    <div class="p-3 ltext-black font-bold text-center" id="main-box">
      <i
      :class="pageIcon">
      </i>
      {{ pageTitle }}
      <div class="border-b-2 border-rhulorange" />
    </div>

    <div class="mb-content text-black text-sm md:text-base">
      <div id="course" class="m-2">
        <h3 class="text-black font-bold my-1 mx-3">{{ progTitle }}</h3>
        <ul id="r-list" class="p-1 text-black">
          <li>Stage: {{ stage }}</li>
          <li>Entry Year: {{ optionYear }}</li>
          <li>Choices for Academic Year: {{ getAcademicYear() }}</li>
        </ul>
      </div>
      <div
        id="requirements"
        class="m-2 my-1 text-black"
        v-if="modulesDict.length != 0"
      >
        <h3 class="font-bold my-1 mx-3">
          Requirements - You are required to take...
        </h3>

        <!-- Requirements list -->
        <ul id="r-list" class="p-1">
          <!-- Core rules -->
          <li v-if="coreModPatterns.length > 0">
            {{ coreModPatterns.length }} core module(s), which are selected by
            default.
          </li>

          <div v-for="optional in optModPatterns" :key="optional.rule_id">
            <!-- Strand rules -->
            <li v-if="optional.constraint_type == 'STRAND'">
              {{ optional.max_quantity }} module(s) beginning with
              {{ optional.mod_code_pattern.split(",").slice(1).join(" or ") }}
              from the ({{
                optional.mod_code_pattern.split(",")[0]
              }}) strand.
            </li>
            <!-- Optional rules -->
            <li v-if="optional.constraint_type == 'OPTS' && optional.min_quantity == optional.max_quantity">
              {{ optional.max_quantity }} optional module(s) beginning with
              {{ optional.mod_code_pattern.split(",").join(" or ") }}
            </li>
            <li v-if="optional.constraint_type == 'OPTS' && optional.min_quantity != optional.max_quantity">
              {{ optional.min_quantity }}-{{ optional.max_quantity }} optional module(s) beginning with
              {{ optional.mod_code_pattern.split(",").join(" or ") }}
            </li>
            <!-- Disc_alt rules -->
            <li v-if="optional.constraint_type == 'DISC_ALT'">
              {{ optional.mod_code_pattern.split(",")[0] }} as a further core
              module, or {{ optional.mod_code_pattern.split(",")[1] }} at the
              discretion of the department.
            </li>
          </div>
        </ul>
      </div>
      <div class="m-2 my-1 text-black">
        <h3 class="font-bold my-1 mx-3">
          Questions
        </h3>
        <ul class="p-1">
          <li>
            <i class="fas fa-comment"></i>
            Visit the
            <button class="
                bg-orange-500
                text-white
                p-1
                hover:bg-orange-600
              ">
              <a href="https://moodle.royalholloway.ac.uk/course/view.php?id=2341&section=9">
                Moodle Forums
              </a>
            </button>
            if you have questions about your module choices.
          </li>
        </ul>
      </div>
      <div
        class="
          block
          grid-cols-2
          md:grid
          \
          justify-center
          max-w-full
          text-black text-l
        "
        id="terms"
      >
        <div
          v-for="(term, index) in modulesDict"
          :key="index"
          class="p-1 m-2 flex flex-col"
        >
          <h3
            v-if="term.coreModules.length > 0 || term.optModules.length > 0"
            class="font-bold border-b-2 border-rhulorange p-1 my-1"
          >
            {{ term.name }}
          </h3>
          <!-- Core modules -->
          <div id="core">
            <h3
              v-if="term.coreModules.length > 0 && !term.hasDiscAlt"
              class="font-bold p-1"
            >
              Core Modules
            </h3>
            <ul v-for="module in term.coreModules" :key="module.mod_code">
              <li
                v-if="!module.disc_alt"
                :style="[
                  module.checked && module.disabled && hasSubmittedChoices
                    ? {'background-color': '#D1FAE5'}
                    : {'background-color': ''},
                ]"
              >
                <input
                  class="rounded hidden"
                  type="checkbox"
                  v-model="module.checked"
                  @change="updateSelected"
                />
                {{ module.mod_code }} - {{ module.title }}
                <Module
                  :mod_code="module.mod_code"
                  :start_year="startAcademicYear"
                />
                <div v-if="module.prerequisites.length > 0" class="prereq">
                  Has prerequisites: {{ module.prerequisites }}
                </div>
                <div
                  v-if="
                    module.prerequisite_of != null &&
                    module.prerequisite_of.length > 0
                  "
                  class="prereq"
                >
                  Prerequisite of: {{ module.prerequisite_of }}
                </div>
              </li>
            </ul>
            <!-- Discretionary alternatives: further core module -->
            <div v-if="term.hasDiscAlt">
              <h3 class="font-bold p-1">
                Further Core Modules
              </h3>
            </div>
            <div>
              <ul v-for="module in term.coreModules" :key="module.mod_code">
                <li
                  v-if="term.hasDiscAlt && module.disc_alt"
                  style="border-color: orange"
                  :style="[
                  module.checked && module.disabled && hasSubmittedChoices
                    ? {'background-color': '#D1FAE5'}
                    : {'background-color': ''},
                ]"
                >
                  <input
                    class="rounded hidden opacity-50 bg-gray-800"
                    type="checkbox"
                    v-model="module.checked"
                    @change="updateSelected"
                    disabled
                  />
                  {{ module.mod_code }} - {{ module.title }}
                  <Module
                    :mod_code="module.mod_code"
                    :start_year="startAcademicYear"
                  />
                  <div v-if="module.prerequisites.length > 0" class="prereq">
                    Has prerequisites: {{ module.prerequisites }}
                  </div>
                  <div
                    v-if="
                      module.prerequisite_of != null &&
                      module.prerequisite_of.length > 0
                    "
                    class="prereq"
                  >
                    Prerequisite of: {{ module.prerequisite_of }}
                  </div>
                </li>
              </ul>
            </div>
          </div>

          <div id="optional">
            <h3
              v-if="term.optModules.length > 0 && !term.hasDiscAlt"
              class="font-bold p-1"
            >
              Optional Modules
            </h3>
            <!-- Optional modules -->
            <ul v-for="module in term.optModules" :key="module.mod_code">
              <li
                v-if="!module.strands.includes(strand) && !module.disc_alt"
                :style="[
                    module.checked
                      ? {'background-color': '#D1FAE5'}
                      : module.previous
                        ? {'background-color': '#EDE9FE'}
                        : {'background-color': ''}
                  ]"
              >
                <input
                  class="rounded bg-opacity-50 bg-gray-800"
                  v-if="module.disabled"
                  type="checkbox"
                  v-model="module.checked"
                  @change="updateSelected"
                  disabled
                />
                <input
                  v-else
                  class="rounded hover:bg-opacity-50 hover:bg-blue-700"
                  type="checkbox"
                  v-model="module.checked"
                  @change="updateSelected"
                />
                {{ module.mod_code }} - {{ module.title }}
                <Module
                  :mod_code="module.mod_code"
                  :start_year="startAcademicYear"
                />
                <div v-if="module.prerequisites.length > 0" class="prereq">
                  Has prerequisites: {{ module.prerequisites }}
                </div>
                <div
                  v-if="
                    module.prerequisite_of != null &&
                    module.prerequisite_of.length > 0
                  "
                  class="prereq"
                >
                  Prerequisite of: {{ module.prerequisite_of }}
                </div>
              </li>
            </ul>
            <!-- Optional modules of strand -->
            <h3
              v-if="
                term.optModules.length > 0 &&
                term.hasStrand && strand != null && strand != ''
              "
              class="font-bold p-1"
            >
              Optional Modules of {{ strand }} strand
            </h3>
            <div>
              <ul v-for="module in term.optModules" :key="module.mod_code">
                <li
                  v-if="module.strands.includes(strand) && !module.disc_alt"
                  style="border-color: red"
                  :style="[
                    module.checked
                      ? {'background-color': '#D1FAE5'}
                      : module.previous
                        ? {'background-color': '#EDE9FE'}
                        : {'background-color': ''}
                  ]"
                >
                  <input
                    class="rounded bg-opacity-50 bg-gray-800"
                    v-if="module.disabled"
                    type="checkbox"
                    v-model="module.checked"
                    @change="updateSelected"
                    disabled
                  />
                  <input
                    v-else
                    class="rounded hover:bg-opacity-50 hover:bg-blue-700"
                    type="checkbox"
                    v-model="module.checked"
                    @change="updateSelected"
                  />
                  {{ module.mod_code }} - {{ module.title }}
                  <Module
                    :mod_code="module.mod_code"
                    :start_year="startAcademicYear"
                  />
                  <div v-if="module.prerequisites.length > 0" class="prereq">
                    Has prerequisites: {{ module.prerequisites }}
                  </div>
                  <div
                    v-if="
                      module.prerequisite_of != null &&
                      module.prerequisite_of.length > 0
                    "
                    class="prereq"
                  >
                    Prerequisite of: {{ module.prerequisite_of }}
                  </div>
                </li>
              </ul>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="p-2 m-2 w-full text-center">
      <button
        type="button"
        class="
          w-full
          inline-flex
          justify-center
          rounded-md
          focus-within:border
          border-transparent
          shadow-sm
          px-4
          py-2
          bg-red-600
          text-l
          my-2
          font-mediumtext-white
          hover:bg-red-700
          focus:outline-none
          focus:ring-2 focus:ring-offset-2
          text-white
          focus:ring-red-500
          sm:ml-3
          sm:w-auto
          sm:text-base
          transition
          1.5s
        "
        v-if="hasSubmittedChoices"
        @click="withdrawChoices"
      >
        <i class="fas fa-times text-xl mx-2"></i>
        Withdraw Choices
      </button>
      <div v-else>
        <button
          type="button"
          class="
          w-full
          inline-flex
          justify-center
          rounded-md
          focus-within:border
          border-transparent
          shadow-sm
          px-4
          py-2
          bg-blue-600
          text-l
          my-2
          font-mediumtext-white
          hover:bg-blue-700
          focus:outline-none
          focus:ring-2 focus:ring-offset-2
          text-white
          focus:ring-green-500
          sm:ml-3
          sm:w-auto
          sm:text-base
          transition
          1.5s
        "
          @click="validateChoices(true)"
        >
          <i class="fas fa-check-square text-xl mx-2"></i>
          Check Choices
        </button>
        <button
          type="button"
          class="
          w-full
          inline-flex
          justify-center
          rounded-md
          focus-within:border
          border-transparent
          shadow-sm
          px-4
          py-2
          bg-green-600
          text-l
          my-2
          font-mediumtext-white
          hover:bg-green-700
          focus:outline-none
          focus:ring-2 focus:ring-offset-2
          text-white
          focus:ring-green-500
          sm:ml-3
          sm:w-auto
          sm:text-base
          transition
          1.5s
        "
          @click="validateChoices(false)"
        >
          <i class="fas fa-check text-xl mx-2"></i>
          <p v-if="isCurrentYear">
            Submit Changes
          </p>
           <p v-else>
            Submit Choices
          </p>
        </button>
      </div>
    </div>

    <alert
      :show="showAlert"
      :close="closeAlert"
      :success="alertSuccess"
      v-bind:title="alertMessage"
      v-bind:description="alertDescription"
    />
  </div>
</template>

<script>
import Module from './Module';
import Alert from './Alert';
const checker = require('../../../shared/checker.js');

export default {
  name: 'ChooseModules',
  props: ['isCurrentYear', 'pageTitle', 'pageIcon', 'stage'],
  components: {
    Module,
    Alert,
  },
  data() {
    return {
      /* General Information */
      hasSubmittedChoices: false,
      items: [],
      /* Alert Information */
      showAlert: false,
      alertMessage: '',
      alertDescription: '',
      alertSuccess: false,
      /* Student Information */
      progTitle: '',
      progCode: localStorage.getItem('prog'),
      email: '',
      entryYear: localStorage.getItem('whenCreated'),
      optionYear: localStorage.getItem('whenCreated'),
      /* Module Information */
      isYINI: false,
      duration: this.getDuration(),
      LDAPModules: localStorage.getItem('ldapRegistrations').trim(),
      modules: [],
      coreModPatterns: [],
      optModPatterns: [],
      /* Module dictionary of modules to pick from */
      modulesDict: {
        term1: {
          name: 'Term 1',
          coreModules: [],
          optModules: [],
          hasDiscAlt: false,
          hasStrand: false,
        },
        term2: {
          name: 'Term 2',
          coreModules: [],
          optModules: [],
          hasDiscAlt: false,
          hasStrand: false,
        },
        bothTerms: {
          name: 'Both Terms',
          coreModules: [],
          optModules: [],
          hasDiscAlt: false,
          hasStrand: false,
        },
      },
      /* Selected modules */
      selected: [],
      currentModChoices: [],
      hasDiscAlt: false,
      /* Option rules */
      optionRules: [],
      strand: '',
      startAcademicYear: this.getStartAcademicYear()
    };
  },
  mounted() {
    /* Checks for Year of Industry before
    getting modules - including core and optional modules */
    this.checkYINI();
    console.log('LDAP MODULES');
    console.log(this.LDAPModules);

    /**
     * Gets the program title.
     */
    this.$axios
      .post(
        `${process.env.VUE_APP_API_URL}/get_degree_title`,
        {
          email: `${localStorage.getItem('user')}`,
          jwt: localStorage.getItem('jwt'),
        },
      )
      .then((response) => {
        this.progTitle = response.data.data;
      })
      .catch((error) => console.log(error));
  },
  methods: {
    /* Alert methods */
    /**
     * Alerts the user with a dialog box
     * @param {String} message - the message to alert
     * @param {String} description - the description of the message
     * @param {Boolean} success - is the alert about a success or failure?
     */
    alertUser(message, description, success) {
      this.alertMessage = message;
      this.alertDescription = description;
      this.alertSuccess = success;
      this.showAlert = true;
    },

    /**
     * Closes the alert dialog box.
     */
    closeAlert() {
      this.showAlert = false;
      (this.alertMessage = ''), (this.alertDescription = '');
    },

    /**
     * Gets the year the academic year being starts
     * @return {int} the year in format YYYY (e.g. 2023)
     */
    getStartAcademicYear() {
      const now = new Date()
      let year = now.getFullYear()
      const change = new Date(year + "-" + process.env.LDAP_CHANGE_MM_DD)
      if (now < change) {
        year--;
      }
      if (!this.isCurrentYear)
        year++
      return year
    },

    /**
     * Gets the current academic year being chosen.
     * @return {String} the year in format XXXX/YYYY
     */
    getAcademicYear() {
      let year = this.getStartAcademicYear()
      return `${year}/${year + 1}`;
    },

    /**
     * Gets the available entry year with the option rules
     * for the given program.
     * @return {*} - the entry year found with available option rules
     * for the program.
     */
    async getAvailableEntryYear() {
      try {
        let res = await fetch(
          `${process.env.VUE_APP_API_URL}/get_available_entry_year`,
          {
            method: 'POST',
            headers: {
              'Content-Type': 'application/json',
            },
            body: JSON.stringify({
              prog_code: localStorage.getItem('prog'),
              entry_year: parseInt(localStorage.getItem('whenCreated')),
              jwt: localStorage.getItem('jwt'),
            }),
          },
        );

        res = await res.json();
        /* Use the most recent year that is the student's entry year or earlier
         as the search for option rules if available */
        if (res.success && res.data.length > 0) {
          const entryYearFound = res.data;
          return entryYearFound;
        }
      } catch (e) {
        console.error(e);
      }

      /* Use student's entry year if none found */
      return localStorage.getItem('whenCreated');
    },

    /**
     * Gets the duration of the student's programme.
     * @return {*} res.data - the data (the duration) from the response
     */
    async getDuration() {
      try {
        let res = await fetch(
          `${process.env.VUE_APP_API_URL}/get_duration`,
          {
            method: 'POST',
            headers: {
              'Content-Type': 'application/json',
            },
            body: JSON.stringify({
              jwt: localStorage.getItem('jwt'),
              prog: localStorage.getItem('prog'),
            }),
          },
        );
        res = await res.json();
        if (!res.success) {
          throw res.error;
        }
        this.duration = res.data;
        // console.log(this.duration);
        return res.data;
      } catch (e) {
        console.error(e);
      }
    },

    /**
     * Checks if the programme is Year In Industry.
     */
    async checkYINI() {
      let isYINI = false;
      const stage = this.stage;
      /* Check if the course includes Year In Industry */
      try {
        let res = await fetch(
          `${process.env.VUE_APP_API_URL}/get_year_in_industry`,
          {
            method: 'POST',
            headers: {
              'Content-Type': 'application/json',
            },
            body: JSON.stringify({
              prog_code: this.progCode,
              jwt: localStorage.getItem('jwt'),
            }),
          },
        );

        res = await res.json();
        // console.log(res);
        /* YINI module found in programme? */
        if (!res.success || res.data.length == 0) {
          isYINI = false;
        } else {
          isYINI = true;
        }
        this.isYINI = isYINI;

        if (isYINI) {
          /* BSci YINI: occurs in third year of course of 4 year duration
        MSci YINI: occurs in fourth year of course of 5 year duration */
          if (this.duration == 4) {
            /* BSci Year of Industry */
            if (stage == 3) {
              /* Filter out modules to only include YINI CS3001 module */
              this.getModules(stage, stage);
            } else if (stage > 3) {
              /* Display modules that would have been taken in
            the year before for a non-YINI course */
              this.getModules(stage, parseInt(stage) - 1);
            } else {
              /* Display modules as normal */
              this.getModules(stage, stage);
            }
          } else {
            /* MSci Year of Industry */
            if (stage == 4) {
              /* Filter out modules to only include YINI CS4001 module */
              this.getModules(stage, stage);
            } else if (stage > 4) {
              /* Display modules that would have been taken in
          the year before for a non-YINI course */
              this.getModules(stage, parseInt(stage) - 1);
            } else {
              /* Display modules as normal */
              this.getModules(stage, stage);
            }
          }
        } else {
          /* Display modules as usual */
          this.getModules(stage, stage);
        }
      } catch (e) {
        console.error(e);
      }
    },

    /**
     * Gets the core modules to select, based on student's program code,
     * entry year, stage and academic year.
     * @param {*} curStage - the stage of the programme to get the core modules.
     * @param {*} modStage - the year in the module code. E.g. CS3888 is 3.
     */
    async getCoreModules(curStage, modStage) {
      try {
        // Empty arrays first
        this.modulesDict.term1.coreModules = [];
        this.modulesDict.term2.coreModules = [];
        this.modulesDict.bothTerms.coreModules = [];

        let res = await fetch(
          `${process.env.VUE_APP_API_URL}/get_core_modules`,
          {
            method: 'POST',
            headers: {'Content-Type': 'application/json'},
            body: JSON.stringify({
              prog_code: localStorage.getItem('prog'),
              entry_year: this.entryYear,
              year: curStage,
              moduleYear: modStage,
              academic_year: this.getAcademicYear(),
              jwt: localStorage.getItem('jwt'),
            }),
          },
        );

        res = await res.json();
        if (!res.success) {
          throw res.error;
        }
        const coreModules = res.data;
        console.log(coreModules);

        // Creates a field 'disabled' for each module in the list 'modules'.
        // Uses mod code pattern as the core module's mod_code
        for (const i in coreModules) {
          if (coreModules[i]) {
            coreModules[i].disabled = true;
            coreModules[i].checked = true;
            coreModules[i].disc_alt = false;
          }
        }

        // Sorts 'coreModules' alphabetically by 'mod_code'.
        coreModules.sort(function(a, b) {
          return a.mod_code > b.mod_code;
        });
        for (const i in coreModules) {
          if (coreModules[i].term == 1) {
            this.modulesDict.term1.coreModules.push(coreModules[i]);
          } else if (coreModules[i].term == 2) {
            this.modulesDict.term2.coreModules.push(coreModules[i]);
          } else {
            this.modulesDict.bothTerms.coreModules.push(coreModules[i]);
          }
        }
        /* Get any discretionary alternative core modules */
        this.getDiscAltModules(curStage);

        this.updateSelected();
      } catch (e) {
        console.error(e);
      }
    },

    /**
     * Gets the optional modules to select, based on student's program code,
     * entry year, stage and academic year.
     * @param {*} curStage the stage of the programme to get the opt. modules.
     */
    async getOptionalModules(curStage) {
      // Empty arrays first
      this.modulesDict.term1.optModules = [];
      this.modulesDict.term2.optModules = [];
      this.modulesDict.bothTerms.optModules = [];

      // Year In Industry has no optional modules
      if (this.isYINI) {
        /* BSci Year in Industry */
        if (this.stage == 3 && this.duration == 4) {
          return;
        }
        /* MSci Year in Industry */
        if (this.stage == 4 && this.duration == 5) {
          return;
        }
      }

      try {
        let res = await fetch(
          `${process.env.VUE_APP_API_URL}/get_optional_modules`,
          {
            method: 'POST',
            headers: {'Content-Type': 'application/json'},
            body: JSON.stringify({
              prog_code: localStorage.getItem('prog'),
              entry_year: this.entryYear,
              year: curStage,
              academic_year: this.getAcademicYear(),
              jwt: localStorage.getItem('jwt'),
            }),
          },
        );

        res = await res.json();
        if (!res.success) {
          throw res.error;
        }
        const optModules = res.data;
        // Creates a field 'disabled' for each module in the optional modules.
        // Sets the strand for each module
        for (const i in optModules) {
          if (optModules[i]) {
            // Set fields
            optModules[i].disabled = false;
            optModules[i].strands = '';
            optModules[i].disc_alt = false;
            optModules[i].checked = false;
            /* Highlights previous selection if
             a user wants to overwrite a request */
            optModules[i].previous = false;

            /* Check for current registrations to
            auto-check modules */
            if (this.hasSubmittedChoices) {
              optModules[i].disabled = true;
            }

            if (this.currentModChoices.includes(
              optModules[i].mod_code)) {
              optModules[i].checked = true;
              optModules[i].previous = true;
            }

            for (const s in this.modules) {
              if (this.modules[s]) {
                // Check if the mod_codes are the same
                if (optModules[i].mod_code == this.modules[s].mod_code) {
                  // Set strand field if strand exists
                  if (this.modules[s].strands)
                    optModules[i].strands = this.modules[s].strands
                  else
                    optModules[i].strands = ""
                }
              }
            }
          }
        }

        // Sorts 'optModules' alphabetically by 'mod_code'.
        optModules.sort(function(a, b) {
          return a.mod_code > b.mod_code;
        });

        this.modulesDict.term1.hasStrand = false;
        this.modulesDict.term2.hasStrand = false;
        this.modulesDict.bothTerms.hasStrand = false;

        /* Organise the optional modules into terms
        Check which terms have strand modules */
        for (const i in optModules) {
          if (optModules[i].term == 1) {
            /* Has strand modules in term 1 */
            if (optModules[i].strands.includes(this.strand)) {
              this.modulesDict.term1.hasStrand = true;
            }
            this.modulesDict.term1.optModules.push(optModules[i]);
          } else if (optModules[i].term == 2) {
            /* Has strand modules in term 2 */
            if (optModules[i].strands.includes(this.strand)) {
              this.modulesDict.term2.hasStrand = true;
            }
            this.modulesDict.term2.optModules.push(optModules[i]);
          } else {
            if (optModules[i].strands.includes(this.strand)) {
              /* Has strand modules in both terms */
              this.modulesDict.bothTerms.hasStrand = true;
            }
            this.modulesDict.bothTerms.optModules.push(optModules[i]);
          }
        }

        this.updateSelected();
      } catch (e) {
        console.error(e);
      }
    },

    /**
     * Gets the discretionary alternative modules to select,
     * based on student's program code, entry year, stage and academic year.
     * @param {*} curStage - the stage of the programme to get
     * the disc_alt modules.
     */
    async getDiscAltModules(curStage) {
      /* Initially no discretionary alternatives */
      this.modulesDict.term1.hasDiscAlt = false;
      this.modulesDict.term2.hasDiscAlt = false;
      this.modulesDict.bothTerms.hasDiscAlt = false;

      /* Year In Industry has no DISC_ALT modules */
      if (this.isYINI) {
        /* BSci Year in Industry */
        if (this.stage == 3 && this.duration == 4) {
          return;
        }
        /* MSci Year in Industry */
        if (this.stage == 4 && this.duration == 5) {
          return;
        }
      }

      try {
        let res = await fetch(
          `${process.env.VUE_APP_API_URL}/get_disc_alt_modules`,
          {
            // check url to make sure their right
            method: 'POST',
            headers: {'Content-Type': 'application/json'},
            body: JSON.stringify({
              prog_code: localStorage.getItem('prog'),
              entry_year: this.entryYear,
              year: curStage,
              academic_year: this.getAcademicYear(),
              jwt: localStorage.getItem('jwt'),
            }),
          },
        );

        res = await res.json();
        /* Discretionary alternatives found in certain program and stage */
        if (res.success && res.data.length > 0) {
          const discAltModules = res.data;

          for (const i in discAltModules) {
            /* Rows of modules usually in pairs
            e.g. row n: Further core module
            row n + 1: and its discretionary alternative */
            if (discAltModules[i]) {
              if (i % 2 == 0) {
                discAltModules[i].mod_code = discAltModules[
                  i
                ].mod_code_pattern.substring(0, 6);
                discAltModules[i].disc_alt = true;
                discAltModules[i].checked = true;
                discAltModules[i].disabled = true;
                discAltModules[i].alt_mod = null;

                /* Only push further core module into core modules */
                if (discAltModules[i].term == 1) {
                  // There are discretionary alternatives in term 1
                  this.modulesDict.term1.hasDiscAlt = true;
                  /* Term 1 - further core module or its disc alt */
                  this.modulesDict.term1.coreModules.push(discAltModules[i]);
                } else if (discAltModules[i].term == 2) {
                  // There are discretionary alternatives in term 2
                  this.modulesDict.term2.hasDiscAlt = true;
                  /* Term 2 - further core module or its disc alt */
                  this.modulesDict.term2.coreModules.push(discAltModules[i]);
                } else {
                  // There are discretionary alternatives in both terms
                  this.modulesDict.bothTerms.hasDiscAlt = true;
                  /* Both Terms - further core module or its disc alt  */
                  this.modulesDict.bothTerms.coreModules.push(
                    discAltModules[i],
                  );
                }
              } else {
                /* Get its discretionary alternative */
                discAltModules[i].mod_code = discAltModules[
                  i
                ].mod_code_pattern.substring(7, 13);
                discAltModules[i].disc_alt = true;
                discAltModules[i].checked = true;
                discAltModules[i].disabled = true;
                discAltModules[i].alt_mod = null;

                /* Set the further core module's alternative module as
                its discretionary alternative,
                but don't push its alternative into moduleDict */
                discAltModules[i - 1].alt_mod = discAltModules[i];
              }
            }
          }

          /* Update selected - core disc_alt modules already checked */
          this.updateSelected();
        }
      } catch (e) {
        console.error(e);
      }
    },

    /**
     * Allows the user to withdraw their choice of optional modules.
     */
    async withdrawChoices() {
      try {
        let res = await fetch(
          `${process.env.VUE_APP_API_URL}/withdraw_choices`,
          {
            method: 'POST',
            headers: {'Content-Type': 'application/json'},
            body: JSON.stringify({
              email: localStorage.getItem('user'),
              jwt: localStorage.getItem('jwt'),
            }),
          },
        );
        res = await res.json();
        if (!res.success) {
          throw res.error;
        }

        this.hasSubmittedChoices = false;
        this.alertUser(
          'Successfully withdrew choices!',
          'Your choices have been withdrawn.',
          true,
        );

        // Deselect and enable all optional modules
        this.enableOptionalModules();
      } catch (e) {
        console.error(e);
      }
    },

    /**
     * Gets ALL modules for a particular degree stage (year).
     * @param {String} curStage The stage to get the modules from.
     * @param {String} modStage The module code "year". E.g. CS3888 is year 3
     */
    async getModules(curStage, modStage) {
      /* Get the available entry year of option rules */
      this.entryYear = await this.getAvailableEntryYear();

      try {
        // Gets all option rules for a specific programme code.
        // TODO: Get enrollment year from LDAP.
        await this.getOptionRules(localStorage.getItem('prog'), this.entryYear);
        let res = await fetch(
          `${process.env.VUE_APP_API_URL}/get_modules`,
          {
            method: 'POST',
            headers: {
              'Content-Type': 'application/json',
            },
            body: JSON.stringify({
              year: modStage,
              academic_year: this.getAcademicYear(),
              jwt: localStorage.getItem('jwt'),
            }),
          },
        );
        res = await res.json();
        if (!res.success) {
          throw res.error;
        }
        const modules = res.data;

        // Creates a field 'disabled' for each module in the list 'modules'.
        for (const i in modules) {
          if (modules[i]) {
            modules[i].disabled = false;
          }
        }

        // Gets all optional modules for specific programme code.
        let optionals = await fetch(
          `${process.env.VUE_APP_API_URL}/get_optionals`,
          {
            method: 'POST',
            headers: {
              'Content-Type': 'application/json',
            },
            body: JSON.stringify({
              prog_code: localStorage.getItem('prog'),
              jwt: localStorage.getItem('jwt'),
            }),
          },
        );
        optionals = await optionals.json();
        optionals = optionals.data;
        // Creates an empty array of modules.
        const modulesShown = [];

        // Iterates over all modules and compares with
        // 'mod_code's in 'optionals'.
        for (let i = 0; i < modules.length; i++) {
          if (modules[i]) {
            const cur = modules[i];
            for (let j = 0; j < optionals.length; j++) {
              if (optionals[j].mod_code == cur.mod_code) {
                modulesShown.push(cur);
              }
            }
          }
        }

        this.displayOptionRules(this.stage);

        // Iterates over all modules and checks if they are core.
        for (const i in modules) {
          // If the module is core, it is pushed to 'modulesShown'.
          if (await this.checkModCode(modules[i].mod_code)) {
            let exists = false;
            for (const j in modulesShown) {
              if (modulesShown[j].mod_code == modules[i].mod_code) {
                exists = true;
                break;
              }
            }
            if (!exists) {
              modulesShown.push(modules[i]);
            }
          }
        }

        // Sorts 'modulesShown' alphabetically by 'mod_code'.
        modulesShown.sort(function(a, b) {
          return a.mod_code > b.mod_code;
        });

        this.modules = modulesShown;

        // Get core and optional modules and any disc_alt modules
        this.getCoreModules(curStage, modStage);
        this.getOptionalModules(modStage);

        // Gets any current registrations that the user may have.
        await this.getCurrentRegistrations(localStorage.getItem('user'));

        this.updateSelected();
      } catch (e) {
        console.error(e);
      }
    },

    /**
     * Attempts to fetch current module registrations from the database
     * (disabling selection).
     * @param {string} email the email associated with the module selections.
     */
    async getCurrentRegistrations(email) {
      try {
        /* Checking if user has LDAP registrations
         * They can only apply to current year */
        let LDAPModulesFound = [];
        if (this.LDAPModules.length > 0 && this.isCurrentYear) {
          /* User has LDAP Modules - split into array of mod codes */
          LDAPModulesFound = this.LDAPModules.split(',');
        }

        /* Searching if a user has made a module choice request */
        let res = await fetch(
          `${process.env.VUE_APP_API_URL}/get_current_mod_choices`,
          {
            method: 'POST',
            headers: {
              'Content-Type': 'application/json',
            },
            body: JSON.stringify({
              email: email,
              jwt: localStorage.getItem('jwt'),
            }),
          },
        );
        res = await res.json();
        console.log(res);
        const userRequest = res.data;
        let currentModChoices = '';

        /* Check if user has module choice request */
        if (res.success && userRequest.length > 0) {
          /* need to calculate choices after change */
          let removed = new Set(
            userRequest[0].removed_choices.trim().split(",")
          )
          let current = new Set(
            userRequest[0].current_modules.trim().split(",").filter(
              (modCode) => !removed.has(modCode)
            )
          )
          for (var modCode of userRequest[0].added_choices.trim().split(","))
            current.add(modCode)

          currentModChoices = [...current].join(",")

          this.hasSubmittedChoices = true
        } else {
          this.hasSubmittedChoices = false
        }

        /* Modules to auto-check */
        let modulesToCheck = [];
        console.log('Ldap Modules:', LDAPModulesFound);
        /* User has LDAP registrations */
        if (LDAPModulesFound.length > 0) {
          /* User registered and request made
           * Display user's request as current choices */
          if (currentModChoices.length > 0) {
            modulesToCheck = currentModChoices.split(',');
          } else {
            /* User registered but no request made:
             * Display LDAP modules as current choices */
            modulesToCheck = LDAPModulesFound;

            /* Check for discretionary alternatives */
            const discAltModules = [];
            for (const term in this.modulesDict) {
              if (this.modulesDict[term]) {
                const curTerm = this.modulesDict[term];
                for (const module in curTerm) {
                  if (curTerm[module]) {
                    if (curTerm[module].disc_alt == true) {
                      discAltModules.push(curTerm[module]);
                    }
                  }
                }
              }
            }

            /* Check if the LDAP registration has the default
            further core module OR the discretionary alternative
            (if so, replace it) */
            for (const i in discAltModules) {
              if (discAltModules[i]) {
                /* If discretionary alternative chosen in LDAP,
                 then replace with that */
                if (LDAPModulesFound.includes(
                  discAltModules[i].alt_mod.mod_code)) {
                  discAltModules[i] = discAltModules[i].alt_mod;
                }
              }
            }
          }
        } else {
          /* User has no LDAP regisrations but has made a request */
          if (currentModChoices) {
            /* User registered: Display user's request as current choices */
            modulesToCheck = currentModChoices.split(',')
          } else {
            /* User is not registered - don't auto-check any boxes */
            modulesToCheck = []
          }
        }

        /* Disable checkboxes if already made choices */
        if (this.hasSubmittedChoices) {
          this.disableOptionalModules()
        } else {
          /* Enable checkboxes otherwise */
          this.enableOptionalModules()
        }

        /* Auto-check optional modules if registered*/
        await this.autoCheckOptionalModules(modulesToCheck)

        /* Current module choices are the modules that are auto-checked */
        this.currentModChoices = modulesToCheck;
      } catch (e) {
        console.error(e);
      }
    },

    /**
     * Automatically check any optional modules already selected
     * if already registered. Note, may have no effect if optional
     * modules not yet fetched.
     * @param {*} modulesToCheck The optional modules to check based
     * on current ldap registrations or last choice.
     */
    autoCheckOptionalModules(modulesToCheck) {
      /* Auto-check boxes for current module choices displayed */

      /* Check optional modules that were selected
          in the current registrations */
      for (const term in this.modulesDict) {
        if (this.modulesDict[term]) {
          for (const opt in this.modulesDict[term].optModules) {
            if (this.modulesDict[term].optModules[opt]) {
              /* Auto-check if the module is part of current choices */
              if (
                modulesToCheck.includes(
                  this.modulesDict[term].optModules[opt].mod_code)
              ) {
                this.modulesDict[term].optModules[opt].checked = true
              }
            }
          }
        }
      }

      this.updateSelected()
    },

    /**
     * Update selected array to include newly checked item.
     */
    updateSelected() {
      this.selected = [];

      for (const term in this.modulesDict) {
        if (term) {
          /* Always check the core modules */
          for (const coreModule in this.modulesDict[term].coreModules) {
            if (this.modulesDict[term].coreModules[coreModule].checked) {
              this.selected.push(
                this.modulesDict[term].coreModules[coreModule],
              );
            }
          }

          /* Check for optional modules that are checked */
          for (const optModule in this.modulesDict[term].optModules) {
            if (this.modulesDict[term].optModules[optModule].checked) {
              this.selected.push(this.modulesDict[term].optModules[optModule]);
            }
          }
        }
      }
    },
    /**
     * Create new entry in module_choices for office staff to review.
     */
    async submitChoices() {
      try {
        /* Only include added modules if next year */
        let selectedModCodes = new Set(
          this.selected
          .filter((e) => !!e)
          .map((e) => e.mod_code)
        )
        let removedModCodes = []
        let addedModCodes = [...selectedModCodes]

        /* If current year, then check for removed modules in new request */
        if (this.isCurrentYear) {
          /* Check for added modules for current year */
          const oldModCodes = new Set(
            localStorage.getItem('ldapRegistrations').split(",")
          )

          /* Make added/removed relative to existing choices */
          if (oldModCodes.size > 0) {
            removedModCodes = [...oldModCodes].filter(
              (x) => !selectedModCodes.has(x)
            )
            addedModCodes = [...selectedModCodes].filter(
              (x) => !oldModCodes.has(x)
            )
          }
        }

        let res = await fetch(
          `${process.env.VUE_APP_API_URL}/submit_choices`,
          {
            method: 'POST',
            headers: {'Content-Type': 'application/json'},
            body: JSON.stringify({
              email: localStorage.getItem('user'),
              stage: this.stage,
              academic_year: this.getAcademicYear(),
              current_modules:
                localStorage.getItem('ldapRegistrations').split(","),
              added_mod_codes: addedModCodes,
              removed_mod_codes: removedModCodes,
              jwt: localStorage.getItem('jwt'),
            }),
          },
        );
        res = await res.json();
        if (!res.success) {
          this.alertUser('Submission error', res.error, false);
          throw res.error;
        } else {
          /* Save the previously selected optional modules in case user
          submits and then withdraws choices and wants to remember
          last requested choices */
          for (const term in this.modulesDict) {
            if (term) {
              /* Check for optional modules that are checked */
              for (const optModule in this.modulesDict[term].optModules) {
                if (this.modulesDict[term].optModules[optModule].checked) {
                  this.modulesDict[term].optModules[optModule].previous = true;
                } else {
                  this.modulesDict[term].optModules[optModule].previous = false;
                }
              }
            }
          }

          this.hasSubmittedChoices = true
          this.alertUser(
            'Successfully submitted choices!',
            'It will take some days for the changes to be implemented. There are manual steps behind the scenes.',
            true,
          );
        }

        // Disable all optional modules
        this.disableOptionalModules();

        // Re-checks current registrations after submit choices
        await this.getCurrentRegistrations(localStorage.getItem('user'));
      } catch (e) {
        console.error(e);
      }
    },

    /**
     * Enables all the checkboxes and unchecks all of the optional modules.
     */
    enableOptionalModules() {
      for (const i in this.modulesDict) {
        if (this.modulesDict[i]) {
          /* Term 1 */
          for (const T1O in this.modulesDict.term1.optModules) {
            if (this.modulesDict.term1.optModules[T1O]) {
              this.modulesDict.term1.optModules[T1O].disabled = false;
              this.modulesDict.term1.optModules[T1O].checked = false;
            }
          }
          /* Term 2 */
          for (const T2O in this.modulesDict.term2.optModules) {
            if (this.modulesDict.term2.optModules[T2O]) {
              this.modulesDict.term2.optModules[T2O].disabled = false;
              this.modulesDict.term2.optModules[T2O].checked = false;
            }
          }
          /* Both terms */
          for (const BTO in this.modulesDict.bothTerms.optModules) {
            if (this.modulesDict.bothTerms.optModules[BTO]) {
              this.modulesDict.bothTerms.optModules[BTO].disabled = false;
              this.modulesDict.bothTerms.optModules[BTO].checked = false;
            }
          }
        }
      }
    },

    /**
     * Disables all the checkboxes of all of the optional modules
     */
    disableOptionalModules() {
      for (const i in this.modulesDict) {
        if (this.modulesDict[i]) {
          /* Term 1 */
          for (const T1O in this.modulesDict.term1.optModules) {
            if (this.modulesDict.term1.optModules[T1O]) {
              this.modulesDict.term1.optModules[T1O].disabled = true;
            }
          }
          /* Term 2 */
          for (const T2O in this.modulesDict.term2.optModules) {
            if (this.modulesDict.term2.optModules[T2O]) {
              this.modulesDict.term2.optModules[T2O].disabled = true;
            }
          }
          /* Both terms */
          for (const BTO in this.modulesDict.bothTerms.optModules) {
            if (this.modulesDict.bothTerms.optModules[BTO]) {
              this.modulesDict.bothTerms.optModules[BTO].disabled = true;
            }
          }
        }
      }
    },

    /**
     * Get option rules for programme code and entry year.
     * @param {text} progCode Internal programme code.
     * @param {text} entryYear Entry year.
     */
    async getOptionRules(progCode, entryYear) {
      try {
        let res = await fetch(
          `${process.env.VUE_APP_API_URL}/get_option_rules`,
          {
            method: 'POST',
            headers: {
              'Content-Type': 'application/json',
            },
            body: JSON.stringify({
              prog_code: progCode,
              entry_year: entryYear,
              jwt: localStorage.getItem('jwt'),
            }),
          },
        );
        res = await res.json();
        if (!res.success) {
          throw res.error;
        }
        this.optionRules = res.data;
      } catch (e) {
        console.error(e);
      }
    },
    /**
     * Displays the rules for optional modules.
     * @param {Integer} year used to show relevent rules for user.
     */
    async displayOptionRules(year) {
      try {
        this.coreModPatterns = [];
        this.optModPatterns = [];
        for (const i in this.optionRules) {
          if (this.optionRules[i]) {
            const cur = this.optionRules[i];
            if (cur.stage == year) {
              if (cur.constraint_type == 'CORE') {
                this.coreModPatterns.push(cur);
              } else {
                this.optModPatterns.push(cur);
                if (cur.constraint_type == 'STRAND') {
                  /* Mod_code_pattern of strand option rules
                  will always have the strand initials first */
                  const curMCP = cur.mod_code_pattern.split(',');
                  this.strand = curMCP[0];
                }
              }
            }
          }
        }
      } catch (e) {
        console.error(e);
      }
    },

    /**
     * Checks if the module is a core or optional module.
     * @param {text} modCode primary key of modules in DB.
     * @return {boolean} true if core module.
     */
    async checkModCode(modCode) {
      for (const i in this.coreModPatterns) {
        if (this.coreModPatterns[i].mod_code_pattern == modCode) {
          return true;
        }
      }
      for (const i in this.optModPatterns) {
        if (this.optModPatterns[i].constraint_type == 'DISC_ALT') {
          const cur = this.optModPatterns[i];
          const defaultModule = cur.mod_code_pattern.substring(0, 6);
          if (defaultModule == modCode) {
            return true;
          }
        }
      }
      return false;
    },

    /**
     * Validate selected module options against option_rules in DB.
     * @param {*} checkOnly - Submit choices after validation or
     *  only validate choices?
     */
    async validateChoices(checkOnly) {
      const rules = this.optionRules;
      let success = true;
      const selectedModCodes = this.selected
        .filter((e) => !!e)
        .map((e) => e.mod_code);
      const stageRules = this.optionRules
        .filter((e) => !!e &&e.stage == this.stage)

      const errors = checker.checkOptionRules(
        this.modules, stageRules, selectedModCodes
      );

      if (errors.length > 0) {
        // only give first error (for now)
        this.alertUser(errors[0][0], errors[0][1], false);
      } else {
        /* No errors - choices passed the test */
        if (checkOnly) {
          /* Don't submit choices after validation check */
          if (success) {
            this.alertUser(
              'Choices valid',
              'Your choices pass the requirements. ' +
                'You can submit your choices',
              true,
            );
          }
        } else {
          /* Submit choices after validation check */
          if (success) {
            this.submitChoices();
          }
        }
      }
    },
  }
}
</script>

<style scoped>
li {
  width: auto;
}

#r-list li {
  border-color: darkblue;
}

.prereq {
  width: 100%;
  text-align: right;
  font-style: italic;
  padding-top: 0.1em;
  white-space: normal;
}

input[type='checkbox'] {
  margin-left: 0.5em;
  margin-right: 0.5em;
  transition: 0.15s;
}
</style>
